var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61158 9.44012C3.63015 10.1627 2.75067 11.0253 2 12C4.34753 15.0482 7.95479 17 12 17C12.0569 17 12.1136 16.9996 12.1703 16.9988L9.9724 14.8009C7.95758 14.4001 6.13394 13.4119 4.67419 12C5.10137 11.5868 5.55971 11.2099 6.04488 10.8734L4.61158 9.44012ZM9 11.0001C9 11.0001 9 11 9 11C9 10.3677 9.19564 9.78101 9.52969 9.29728C8.95481 9.43817 8.39701 9.62727 7.8605 9.86062L6.35902 8.35914C8.06102 7.48878 9.97567 7 12 7C16.0452 7 19.6525 8.9518 22 12C20.1905 14.3496 17.6326 16.0477 14.7026 16.7027L12.9561 14.9563C15.3948 14.7322 17.6113 13.6583 19.3258 12C17.9737 10.6923 16.3095 9.74799 14.4703 9.29728C14.8044 9.78101 15 10.3677 15 11C15 12.6569 13.6569 14 12 14C12 14 11.9999 14 11.9999 14L9 11.0001Z",
    fill: "#220C4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.82837,
    y: 4,
    width: 20,
    height: 2,
    transform: "rotate(45 4.82837 4)",
    fill: "#220C4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.9c7daf11154b176e1f6d2341734815ae.svg";
export { ForwardRef as ReactComponent };